

























import { computed, defineComponent, ref, useContext, useFetch } from '@nuxtjs/composition-api';
import CartSummary from './CartSummary.vue';
import { useApi, useCart, useCartView, useConfig } from '~/composables';
import CartItem from './CartItem.vue';
import { extendProductsForBox, getIsBook } from '~/utils/solepro/products';
import { useCategoryStore } from '~/modules/catalog/category/stores/category';
import axios from 'axios';
import GET_CART_ITEM_DATAS from '~/modules/catalog/product/queries/solepro/getCartItemDatas.gql'
import { getCartItemPaymentFrequency, getLabels, getSecondLine } from '~/utils/helpers/cart';
import { ADD_TO_CART_TIPO_ABBONAMENTO_PARAMS, DURATION_MATCHING } from '~/utils/constants/product';
import {useTemporizedCart} from '~/composables/useTemporizedCart';
import useLoader from '~/composables/useLoader';
import { trackCartView } from '~/helpers/trackings/24orepro/cart';
import { getAxiosConfigs } from '~/utils/solepro/functions';

export default defineComponent({
    components: {
        CartSummary,
        CartItem
    },
    setup() {
        const cartView = useCartView();
        const {cart} = useCart()
        const categoryStore = useCategoryStore();
        const { query } = useApi()
        const { app, $fc } = useContext();
        const i18n = app.i18n;
        const  { deletedProducts } = useTemporizedCart();
        const { setIsLoading } = useLoader()
        const { config } = useConfig()
        const tmpProducts=ref([]);
        useFetch(async () => {
            setIsLoading(true)
            await categoryStore.load();
            const categories = categoryStore.rawCategories?.items[0].children;
            const skus = cart.value.items.map(el => {
                let tmp = [el.product.sku]
                el['configured_variant'] ? tmp.push(el['configured_variant'].sku) : null;
                return tmp;
            }).flat()
            const promises = cart.value.items.map(p=>axios.get(`/sole-api/product/getProduct?sku=${p.product.sku}`));
            const responses = await Promise.all(promises)
            let fullDatas = {}
            responses.forEach(el=>{
                fullDatas[el.data.sku] = el.data
            })

            const { data } = await query(GET_CART_ITEM_DATAS, { filter: { sku: { in: skus } } });
            const { data: attributeSets } = await axios.get('/sole-api/product/getAttributeSets',{...getAxiosConfigs(app, config)});
            const productsData = extendProductsForBox(categories, cart.value.items.map(i => i.product))
            /**@TODO verificare productTypeTag  */
            tmpProducts.value = cart.value.items.map((cartItem, index)=>{
                let parentProduct = data['products'].items.find(el => el.sku == cartItem.product.sku)
                if(!parentProduct)return;
                parentProduct.attributeSetName = attributeSets[parentProduct.attribute_set_id];
                const variantSku = cartItem['configured_variant'] ? cartItem['configured_variant'].sku : null;
                const product = productsData.find(el => el.sku == parentProduct.sku);
                const paymentFrequency = getCartItemPaymentFrequency(cartItem, parentProduct)
                let moduleSkus;
                try{
                    /** @TODO find a better way than includes('modul') */
                    moduleSkus = cartItem.bundle_options.find(opt=> opt.label.includes('modul') && opt.values.every(v=>v.sku)).values.map(el=>el.sku)
                }catch(e){}
                return {
                    ...cartItem,
                    index,
                    deleted:false,
                    product,
                    moduleSkus,
                    tipoAbbonamento: paymentFrequency ? ADD_TO_CART_TIPO_ABBONAMENTO_PARAMS[DURATION_MATCHING[paymentFrequency]] : null,
                    boxDatas:fullDatas[parentProduct.sku],
                    isBook: getIsBook(parentProduct),
                    secondLine: getSecondLine(i18n, cartItem, parentProduct, variantSku, paymentFrequency),
                    rowTotals: getLabels(i18n, $fc, cartItem, fullDatas[parentProduct.sku], DURATION_MATCHING[paymentFrequency], variantSku ) // @TODO define span
                }

            }).filter(el=>!!el)
            setIsLoading(false)
            await trackCartView(tmpProducts.value)
        })
        const productsToShow = computed(()=>{
            let tmp = Object.assign(tmpProducts.value);
            deletedProducts.value.forEach(p=>{
                tmp.splice(p.index, 0, p);
            })
            return tmp
        })
        return {
            ...cartView,
            productsToShow,
            deletedProducts,
            checkpdt: cart.value.items
        }
    }
})
